module.exports = __webpack_public_path__ + "static/card_2-083c9a15b5f9cc607bbf7449ce8c1f47.png";